export default __webpack_public_path__ + "static/media/Spinner-1s-200px.348e10f7.svg";